import React, { useEffect, useState, useRef } from "react";
import { Paper } from "@material-ui/core";
import {
  Table,
  Modal,
  Spinner,
  Alert,
  Form,
  ModalFooter,
  Badge,
  Button,
} from "react-bootstrap";
import { Modal as AntdModal, DatePicker } from "antd";
import { baseUrl } from "../../../../services/config";
import "./studentdues.css";
import ReactToPrint from "react-to-print";
import { LinearProgress } from "@material-ui/core";
import { message } from "antd";
import { Toaster, toast } from "react-hot-toast";
import { array } from "prop-types";
import {
  sendDueFeeNotifications,
  sendNotificationsInBatches2,
} from "../../../../components/SendNotifications/SendNotifications";
import DueFeeExport from "./DueFeeExport";
import { upperCase } from "lodash";
import { useSelector } from "react-redux";
import { PremissionChecker } from "../../../../services/PremissionChecker";

const { RangePicker } = DatePicker;

const StudentDueFee = () => {
  const componentRef = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const user = useSelector((state) => state.user.user);

  //print states
  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");

  const [session, setSession] = useState(
    PremissionChecker(user, "system_reports.session_wise_due_fee")
      ? true
      : false
  );
  const [checkallcheckbox, setcheckallcheckbox] = useState(false);
  const [campus, setCampus] = useState(
    PremissionChecker(user, "system_reports.session_wise_due_fee")
      ? false
      : true
  );
  const [courses, setCourses] = useState(false);
  const [classes, setClasses] = useState(false);
  const [section, setSection] = useState(false);
  const [loading, setLoading] = useState(false);
  const [male, setMale] = useState(false);
  const [female, setFemale] = useState(false);
  const [both, setBoth] = useState(true);
  const [yearId, setYearId] = useState("");
  const [studentStatus, setStudentStatus] = useState(2);
  const [feeType, setFeeType] = useState("");
  const [studentsData, setStudentsData] = useState(0);
  const [sessionData, setSessionData] = useState([]);
  const [campuses, setCampusData] = useState(user.campuses || []);
  const [allcheckboxes, setallcheckboxes] = useState([]);
  const [studentIds, setStudentIds] = useState([]);
  const [selected, setSelected] = useState(
    PremissionChecker(user, "system_reports.session_wise_due_fee")
      ? "session"
      : "campus"
  );
  const [gender, setGender] = useState("both");
  const [printData, setPrintData] = useState([]);
  const [printClassData, setClassPrintData] = useState([]);
  const [printLoading, setprintLoading] = useState(false);
  const [grandTotal, setGrandTotal] = useState(0);
  const [messageModel, setMessageModel] = useState(false);
  const [buttonDisabled, setbuttonDisabled] = useState(false);
  const [notificationConfirmModal, setNotificationConfirmModal] = useState(
    false
  );
  const [fee_types, setfee_types] = useState([]);
  let authtoken = localStorage.getItem("userToken");
  const [startDate, setStartDate] = useState("");
  const [endDate, setendDate] = useState("");
  const [messageArray, setMessageArray] = useState([]);
  const [myNotificationArray, setMyNotificationArray] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const pageStyle = `
  @page {
    size: legal portrait !important;
    margin-bottom: 1in;
  }
`;
  const key = "updatable";
  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);
  const [overDueDate, setOverDueDate] = useState(0);

  const [campusCourseData, setCampusCourseData] = useState([]);
  const [courseClassData, setCourseClassData] = useState([]);
  const [classSectionData, setClassSectionData] = useState([]);

  const [campusId, setCampusId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [classId, setClassId] = useState("");
  const [sectionId, setSectionId] = useState("");

  const [selectedChallans, setSelectedChallans] = useState([]);
  const [mainCheckBoxChecked, setmaincheckboxChecked] = useState(false);
  const searchClicked = useRef(false);
  const firstTimeLoad = useRef(false);

  useEffect(() => {
    if (!firstTimeLoad.current) {
      firstTimeLoad.current = true;
      sessions();
      getFeeTypes();
      getSettingData();
    }

    if (searchClicked.current) {
      searchClicked.current = false;
      setAllCheckboxes(true);
    } else {
      checkAllCheckBoxes();
    }
  }, [[], selectedChallans]);

  const sessions = async () => {
    await fetch(`${baseUrl}/session`, {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setSessionData(data.payload);
        data.payload.forEach((session, index) => {
          if (session.active_academic_year == "1") {
            setYearId(session.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onCampusChange = (id) => {
    setCampusId(id);
    getCampusCourses(id);
  };

  const getCampusCourses = async (campusId) => {
    setCampusCourseData([]);
    setCourseClassData([]);
    setClassSectionData([]);

    if (campusId == "") {
      return alert.error("Please Select Campus");
    }
    await fetch(`${baseUrl}/campus-all-courses/${campusId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCourseId("");
          setClassId("");
          setCampusCourseData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onCourseChange = (id) => {
    setCourseId(id);
    getCourseClasses(id);
  };

  const getCourseClasses = async (courseId) => {
    setCourseClassData([]);
    setClassSectionData([]);

    if (courseId == "") {
      return alert.error("Please Select Course");
    }
    await fetch(`${baseUrl}/course-all-classes/${courseId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setClassId("");
          setCourseClassData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onClassChange = (id) => {
    setClassId(id);
    getSectionsList(id);
  };

  const getSectionsList = (id) => {
    if (id == "" || campusId == "" || courseId == "") {
      alert.error("Please Select Campus / Course/ Class");
      return;
    }
    fetch(`${baseUrl}/class-section/${campusId}/${courseId}/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setClassSectionData(data.payload);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getFeeTypes = () => {
    fetch(`${baseUrl}/feestypes`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setfee_types(data.payload);
        });
      })
      .catch((err) => {});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // if (loginAccount == "Campus" && campusId == "") {
    if (
      PremissionChecker(user, "system_reports.session_wise_due_fee")
        ? undefined
        : campusId == ""
    ) {
      toast.error("Campus is required");
      return;
    }

    const fdata = new FormData();

    fdata.append("session_wise", session ? 1 : 0);
    fdata.append("campus_wise", campus ? 1 : 0);
    fdata.append("course_wise", courses ? 1 : 0);
    fdata.append("class_wise", classes ? 1 : 0);
    fdata.append("section_wise", section ? 1 : 0);
    fdata.append("year_id", yearId);
    fdata.append("campus_id", campusId);
    fdata.append("course_id", courseId);
    fdata.append("student_class_id", classId);
    fdata.append("global_section_id", sectionId);
    fdata.append("male", male ? 1 : 0);
    fdata.append("female", female ? 1 : 0);
    fdata.append("both", both ? 1 : 0);
    fdata.append("student_status", studentStatus);
    fdata.append("type_of_fees", feeType);
    fdata.append("start_date", startDate + "-01");
    fdata.append("end_date", endDate + "-01");
    fdata.append("over_due", overDueDate);

    setLoading(true);

    fetch(`${baseUrl}/student-due-fee`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
      body: fdata,
    }).then((resp) => {
      resp.json().then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            searchClicked.current = true;
            setStudentsData(data.payload.students);
            setLoading(false);
            setcheckallcheckbox(false);
          }
        }
      });
    });
  };

  const onRadioButtonClick = (e) => {
    const value = e.target.value;
    setCampusId("");
    setClassId("");
    setCourseId("");
    setSectionId("");
    setSelected(e.target.value);
    if (value == "session") {
      setSession(true);
      setCampus(false);
      setCourses(false);
      setClasses(false);
      setSection(false);
    }
    if (value == "campus") {
      setSession(false);
      setCampus(true);
      setCourses(false);
      setClasses(false);
      setSection(false);
    }
    if (value == "course") {
      setSession(false);
      setCampus(false);
      setCourses(true);
      setClasses(false);
      setSection(false);
    }
    if (value == "class") {
      setSession(false);
      setCampus(false);
      setCourses(false);
      setClasses(true);
      setSection(false);
    }
    if (value == "section") {
      setSession(false);
      setCampus(false);
      setCourses(false);
      setClasses(false);
      setSection(true);
    }
  };

  const ongenderButtonClick = (e) => {
    const value = e.target.value;

    setGender(e.target.value);
    if (value == "male") {
      setMale(true);
      setFemale(false);
      setBoth(false);
    }
    if (value == "female") {
      setMale(false);
      setFemale(true);
      setBoth(false);
    }

    if (value == "both") {
      setMale(false);
      setFemale(false);
      setBoth(true);
    }
  };

  const getMonthName = (date) => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const d = new Date(date);

    return `${monthNames[d.getMonth()]}`;
  };

  const handleBeforePrint = React.useCallback(() => {}, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleAfterPrint = React.useCallback(() => {}, []);

  const getFeeSum = (array) => {
    let sum = 0;
    array.forEach((element) => {
      sum += parseInt(element.fee_challan_details[0].amount);
    });
    return sum;
  };

  const sendMessage = () => {
    setbuttonDisabled(false);
    setMessageModel(false);
    let data = {
      student_ids: messageArray,
    };

    fetch(`${baseUrl}/student-due-fee-sms`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata) {
            if (data.metadata.success) {
              messageApi.open({
                key,
                type: "success",
                content: "Successfully Send",
                duration: 1,
              });
              setbuttonDisabled(false);
              setMessageModel(false);
            } else {
              messageApi.open({
                key,
                type: "error",
                content: "Something went wronge",
                duration: 4,
              });
              setbuttonDisabled(false);
            }
          }
          console.log(data);
        })
      )

      .catch((err) => {
        console.log(err);
      });
  };

  const handleMainCheckboxClick = () => {
    if (mainCheckBoxChecked) setAllCheckboxes(false);
    else setAllCheckboxes(true);
  };

  const setAllCheckboxes = (value) => {
    setmaincheckboxChecked(value);
    if (value) {
      setSelectedChallans([]);
    }

    studentsData.map((item, i) => {
      item.checked = value;
      if (!value) {
        RemoveSelectedChallan(item);
      } else {
        AddSelectedChallan(item);
      }
    });
  };

  const checkAllCheckBoxes = () => {
    if (studentsData.length == selectedChallans.length) {
      setmaincheckboxChecked(true);
    } else if (mainCheckBoxChecked) {
      setmaincheckboxChecked(false);
    }
  };

  const handleChallansCheckBoxClick = (e, index) => {
    studentsData.map((item, i) => {
      if (item.id == index) {
        item.checked = !item.checked;

        if (item.checked) {
          AddSelectedChallan(item);
        } else {
          RemoveSelectedChallan(item);
        }
      }
    });
  };

  const AddSelectedChallan = (item) => {
    setSelectedChallans((prevSelectedChallans) => [
      ...prevSelectedChallans,
      item,
    ]);
  };

  const RemoveSelectedChallan = (item) => {
    setSelectedChallans((prevSelectedChallans) =>
      prevSelectedChallans.filter((std) => std.id !== item.id)
    );
  };

  const handlePrint = () => {
    setShow(true);
    setprintLoading(true);
    let selected_student = selectedChallans.map((item, index) =>
      String(item.id)
    );
    fetch(`${baseUrl}/student-due-fee-print-list`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify({
        type_of_fees: feeType,
        student_ids: selected_student,
        start_date: startDate + "-01",
        end_date: endDate + "-01",
        over_due: overDueDate,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setprintLoading(false);
        setPrintData(data.payload);

        let sum = 0;
        let grandtotal = data.payload.forEach((item) => {
          sum += item.amount;
          return sum;
        });
        setGrandTotal(sum);
        setClassPrintData(data.payload.classes);
      })
      .catch((err) => {
        console.log(err);
        setprintLoading(false);
      });
  };

  const datePicker = (value, dateString) => {
    setStartDate(dateString[0]);
    setendDate(dateString[1]);
  };

  let num = 0;
  let num2 = 0;
  const todayDate = () => {
    var date = new Date();
    var monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    var day = date.getDate();
    var month = monthNames[date.getMonth()];
    var year = date.getFullYear();
    var formattedDate = day + " " + month + " " + year;

    return formattedDate;
  };
  const currentTime = () => {
    var currentDate = new Date();

    var hours = currentDate.getHours();
    var minutes = currentDate.getMinutes();
    var seconds = currentDate.getSeconds();

    var formattedHours = hours < 10 ? "0" + hours : hours;
    var formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
    var formattedSeconds = seconds < 10 ? "0" + seconds : seconds;
    var formattedTime =
      formattedHours + ":" + formattedMinutes + ":" + formattedSeconds;

    return formattedTime;
  };

  const STUD_STATUS = [
    {
      id: 1,
      title: "Registered Only",
    },
    {
      id: 2,
      title: "Admission Only",
    },
    {
      id: 3,
      title: "Applied For Admission",
    },
    {
      id: 4,
      title: "Struck Off",
    },
    {
      id: 5,
      title: "Passout",
    },
    {
      id: 6,
      title: "Leaving",
    },
    {
      id: 7,
      title: "Migrate",
    },
  ];
  const feeChalanChecker = (arr) => {
    let res = arr.filter((item) => {
      if (item.fee_challan_details.length > 0) {
        return item;
      }
    });
    return res;
  };

  const feeMonthsChecker = (fee_challans, getMonthName) => {
    let feeMonths = [];

    let res = fee_challans.filter((item) => {
      if (item.fee_challan_details.length > 0) {
        item.fee_challan_details.forEach((detail) => {
          const monthName = getMonthName(detail.fee_month);
          if (!feeMonths.includes(monthName)) {
            feeMonths.push(monthName); // Add the month name if it's not already in the array
          }
        });
        return item;
      }
    });

    const feeMonthsLength = feeMonths.length; // Get the length of feeMonths array

    return { res, feeMonths, feeMonthsLength }; // Return the array, month names, and its length
  };

  const monthsNameString = (arr) => {
    let monthArray = [];
    arr.map((item) => {
      monthArray.push(getMonthName(item.fee_challan_details[0]?.fee_month));
    });
    return monthArray.join(",");
  };
  const sendMonthsToApi = (arr) => {
    let monthArray = [];
    arr.map((item) => {
      monthArray.push(item.fee_challan_details[0]?.fee_month);
    });
    return monthArray;
  };

  const sendMesagePreview = () => {
    let selected_student = selectedChallans.map((item, index) => item.id);
    let makePayload = [];
    const selectedFeeses = studentsData.filter((item) =>
      selected_student.includes(item.id)
    );
    selectedFeeses.map((fc) => {
      makePayload.push({
        studentId: fc.id,
        months: sendMonthsToApi(feeChalanChecker(fc.fee_challans)),
      });
    });
    setMessageArray(makePayload);
    setMessageModel(true);
  };

  const mainTableGrandTotal = (array) => {
    if (array.length) {
      let sum = 0;
      array.forEach((student) => {
        const challansSum = getFeeSum(feeChalanChecker(student.fee_challans));
        return (sum += challansSum);
      });
      return sum;
    }
  };

  // const sendNotification = () => {
  //   let selected_student = selectedChallans.map((item, index) =>
  //     String(item.id)
  //   );
  //   const notificationArray = [];
  //   const selectedFeeses = studentsData.filter((item) =>
  //     selected_student.includes(item.id)
  //   );
  //   selectedFeeses.map((st) => {
  //     notificationArray.push({
  //       id: st.notification_id,
  //       title: "Due Fee Alert",
  //       description: `We have been checking accounts and found that there is some due fee pending (Rs. ${getFeeSum(
  //         feeChalanChecker(st.fee_challans)
  //       )}) of your child ${st.name}(${
  //         st.admission_id
  //       }) for the month of ${monthsNameString(
  //         feeChalanChecker(st.fee_challans)
  //       )}. Please pay the fees at the earliest`,
  //     });
  //   });
  //   if (notificationArray.length > 0) {
  //     setMyNotificationArray(notificationArray);
  //     setNotificationConfirmModal(true);
  //   } else {
  //     toast.error("Please Select At Least One Student");
  //   }
  // };
  const sendNotification = () => {
    const notificationArray = [];
    const selectedFeeses = studentsData.filter((item) =>
      studentIds.includes(item.id)
    );
    selectedFeeses.map((st) => {
      notificationArray.push({
        id: st.notification_id,
        title: "Due Fee Alert",
        description: `We have been checking accounts and found that there is some due fee pending (Rs. ${getFeeSum(
          feeChalanChecker(st.fee_challans)
        )}) of your child ${st.name}(${
          st.admission_id
        }) for the month of ${monthsNameString(
          feeChalanChecker(st.fee_challans)
        )}. Please pay the fees at the earliest`,
      });
    });
    if (notificationArray.length > 0) {
      setMyNotificationArray(notificationArray);
      setNotificationConfirmModal(true);
    } else {
      toast.error("Please Select At Least One Student");
    }
  };
  const sendMessageToStudents = () => {
    sendDueFeeNotifications(myNotificationArray);
    toast.success("Notification Successfully Sent");
    setNotificationConfirmModal(false);
  };
  // const sendMessageToStudents = () => {
  //   sendNotificationsInBatches2(myNotificationArray);
  //   toast.success("Notification Successfully Sent");
  //   setNotificationConfirmModal(false);
  // };

  // const renderTableRow = (student, index) => {
  //   if (student.fee_challans.length > 3) {
  //     return (
  //       <React.Fragment key={index}>
  //         <tr id="tbl">
  //           <td style={{ textAlign: "start" }}>
  //             <input type="checkbox" style={{ display: "none" }} />
  //             <label className="checkbox checkbox-single">
  //               <input
  //                 type="checkbox"
  //                 value={student.id}
  //                 key={student.id}
  //                 onClick={(e) => {
  //                   handleChallansCheckBoxClick(e, student.id);
  //                 }}
  //                 checked={student.checked ?? false}
  //                 readOnly

  //                 // type="checkbox"
  //                 // key={student.id}
  //                 // onClick={(e) => {
  //                 //   checkBoxClick(e, student.id);
  //                 // }}
  //                 // checked={student.checked}
  //                 // value={allcheckboxes[index]}
  //                 // readOnly
  //               />
  //               <span />
  //             </label>
  //           </td>
  //           <td className="text_align_start" style={{ color: "red" }}>
  //             {student.admission_id}
  //           </td>
  //           <td className="text_align_start" style={{ color: "red" }}>
  //             {student.name}
  //           </td>
  //           <td className="text_align_start" style={{ color: "red" }}>
  //             {student.father_name}
  //           </td>
  //           <td className="text-center" style={{ color: "red" }}>
  //             {student.mobile_no}
  //           </td>

  //           <td className="text-center" style={{ color: "red" }}>
  //             {student?.student_class?.name}
  //           </td>
  //           <td className="text-center" style={{ color: "red" }}>
  //             {student?.global_section?.name}
  //           </td>

  //           <td>
  //             {feeChalanChecker(student.fee_challans).map((item, i) => (
  //               <React.Fragment key={i}>
  //                 <span className="text-center" style={{ color: "red" }}>
  //                   {i == "0" ? "" : ","} {/* {getMonthName(item.due_date)} */}
  //                   {getMonthName(item.fee_challan_details[0]?.fee_month)}
  //                 </span>
  //               </React.Fragment>
  //             ))}
  //           </td>

  //           <td style={{ color: "red" }} className="text-center">
  //             {feeChalanChecker(student?.fee_challans).length}
  //           </td>

  //           <td style={{ color: "red" }} className="text-center">
  //             {getFeeSum(feeChalanChecker(student.fee_challans))}
  //           </td>
  //         </tr>
  //       </React.Fragment>
  //     );
  //   } else if (student.fee_challans.length == 3) {
  //     return (
  //       <React.Fragment key={index}>
  //         <tr id="tbl">
  //           <td style={{ textAlign: "start" }}>
  //             <input type="checkbox" style={{ display: "none" }} />
  //             <label className="checkbox checkbox-single">
  //               <input
  //                 type="checkbox"
  //                 value={student.id}
  //                 key={student.id}
  //                 onClick={(e) => {
  //                   handleChallansCheckBoxClick(e, student.id);
  //                 }}
  //                 checked={student.checked ?? false}
  //                 readOnly
  //               />
  //               <span />
  //             </label>
  //           </td>
  //           <td className="text_align_start" style={{ color: "#fd12b3" }}>
  //             {student.admission_id}
  //           </td>
  //           <td className="text_align_start" style={{ color: "#fd12b3" }}>
  //             {student.name}
  //           </td>
  //           <td className="text_align_start" style={{ color: "#fd12b3" }}>
  //             {student.father_name}
  //           </td>
  //           <td className="text-center" style={{ color: "#fd12b3" }}>
  //             {student.mobile_no}
  //           </td>

  //           <td className="text-center" style={{ color: "#fd12b3" }}>
  //             {student?.student_class?.name}
  //           </td>
  //           <td className="text-center" style={{ color: "#fd12b3" }}>
  //             {student?.global_section?.name}
  //           </td>

  //           <td>
  //             {feeChalanChecker(student.fee_challans).map((item, i) => (
  //               <React.Fragment key={i}>
  //                 <span className="text-center" style={{ color: "#fd12b3" }}>
  //                   {i == "0" ? "" : ","} {/* {getMonthName(item.due_date)} */}
  //                   {getMonthName(item.fee_challan_details[0]?.fee_month)}
  //                 </span>
  //               </React.Fragment>
  //             ))}
  //           </td>

  //           <td style={{ color: "#fd12b3" }} className="text-center">
  //             {feeChalanChecker(student?.fee_challans).length}
  //           </td>

  //           <td style={{ color: "#fd12b3" }} className="text-center">
  //             {getFeeSum(feeChalanChecker(student.fee_challans))}
  //           </td>
  //         </tr>
  //       </React.Fragment>
  //     );
  //   } else if (student.fee_challans.length == 2) {
  //     return (
  //       <React.Fragment key={index}>
  //         <tr id="tbl">
  //           <td style={{ textAlign: "start" }}>
  //             <input type="checkbox" style={{ display: "none" }} />
  //             <label className="checkbox checkbox-single">
  //               <input
  //                 type="checkbox"
  //                 value={student.id}
  //                 key={student.id}
  //                 onClick={(e) => {
  //                   handleChallansCheckBoxClick(e, student.id);
  //                 }}
  //                 checked={student.checked ?? false}
  //                 readOnly
  //               />
  //               <span />
  //             </label>
  //           </td>
  //           <td className="text_align_start" style={{ color: "green" }}>
  //             {student.admission_id}
  //           </td>
  //           <td className="text_align_start" style={{ color: "green" }}>
  //             {student.name}
  //           </td>
  //           <td className="text_align_start" style={{ color: "green" }}>
  //             {student.father_name}
  //           </td>
  //           <td className="text-center" style={{ color: "green" }}>
  //             {student.mobile_no}
  //           </td>

  //           <td className="text-center" style={{ color: "green" }}>
  //             {student?.student_class?.name}
  //           </td>
  //           <td className="text-center" style={{ color: "green" }}>
  //             {student?.global_section?.name}
  //           </td>

  //           <td>
  //             {feeChalanChecker(student.fee_challans).map((item, i) => (
  //               <React.Fragment key={i}>
  //                 <span className="text-center" style={{ color: "green" }}>
  //                   {i == "0" ? "" : ","} {/* {getMonthName(item.due_date)} */}
  //                   {getMonthName(item.fee_challan_details[0]?.fee_month)}
  //                 </span>
  //               </React.Fragment>
  //             ))}
  //           </td>

  //           <td style={{ color: "green" }} className="text-center">
  //             {feeChalanChecker(student?.fee_challans).length}
  //           </td>

  //           <td style={{ color: "green" }} className="text-center">
  //             {getFeeSum(feeChalanChecker(student.fee_challans))}
  //           </td>
  //         </tr>
  //       </React.Fragment>
  //     );
  //   } else {
  //     return (
  //       <React.Fragment key={index}>
  //         <tr id="tbl">
  //           <td style={{ textAlign: "start" }}>
  //             <input type="checkbox" style={{ display: "none" }} />
  //             <label className="checkbox checkbox-single">
  //               <input
  //                 type="checkbox"
  //                 key={student.id}
  //                 onClick={(e) => {
  //                   checkBoxClick(e, student.id);
  //                 }}
  //                 checked={student.checked}
  //                 value={allcheckboxes[index]}
  //                 readOnly
  //               />
  //               <span />
  //             </label>
  //           </td>
  //           <td className="text_align_start" style={{ color: "black" }}>
  //             {student.admission_id}
  //           </td>
  //           <td className="text_align_start" style={{ color: "black" }}>
  //             {student.name}
  //           </td>
  //           <td className="text_align_start" style={{ color: "black" }}>
  //             {student.father_name}
  //           </td>
  //           <td className="text-center" style={{ color: "black" }}>
  //             {student.mobile_no}
  //           </td>

  //           <td className="text-center" style={{ color: "black" }}>
  //             {student?.student_class?.name}
  //           </td>
  //           <td className="text-center" style={{ color: "black" }}>
  //             {student?.global_section?.name}
  //           </td>

  //           <td>
  //             {feeChalanChecker(student.fee_challans).map((item, i) => (
  //               <React.Fragment key={i}>
  //                 <span className="text-center" style={{ color: "black" }}>
  //                   {i == "0" ? "" : ","} {/* {getMonthName(item.due_date)} */}
  //                   {getMonthName(item.fee_challan_details[0]?.fee_month)}
  //                 </span>
  //               </React.Fragment>
  //             ))}
  //           </td>

  //           <td style={{ color: "black" }} className="text-center">
  //             {feeChalanChecker(student?.fee_challans).length}
  //           </td>

  //           <td style={{ color: "black" }} className="text-center">
  //             {getFeeSum(feeChalanChecker(student.fee_challans))}
  //           </td>
  //         </tr>
  //       </React.Fragment>
  //     );
  //   }
  // };

  const renderTableRow = (student, index) => {
    const { res, feeMonths, feeMonthsLength } = feeMonthsChecker(
      student.fee_challans,
      getMonthName
    );
    if (feeMonthsLength > 3) {
      return (
        <>
          <tr id="tbl">
            <td style={{ textAlign: "start" }}>
              <input type="checkbox" style={{ display: "none" }} />
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  key={student.id}
                  onClick={(e) => {
                    handleChallansCheckBoxClick(e, student.id);
                  }}
                  checked={student.checked}
                  value={allcheckboxes[index]}
                />
                <span />
              </label>
            </td>
            <td className="text_align_start" style={{ color: "red" }}>
              {student.admission_id}
            </td>
            <td className="text_align_start" style={{ color: "red" }}>
              {student.name}
            </td>
            <td className="text_align_start" style={{ color: "red" }}>
              {student.father_name}
            </td>
            <td className="text-center" style={{ color: "red" }}>
              {student.mobile_no}
            </td>

            <td className="text-center" style={{ color: "red" }}>
              {student?.student_class?.name}
            </td>
            <td className="text-center" style={{ color: "red" }}>
              {student?.global_section?.name}
            </td>

            <td>
              <span className="text-center" style={{ color: "red" }}>
                {feeMonths.join(", ")}
              </span>
            </td>

            <td style={{ color: "red" }} className="text-center">
              {feeMonthsLength}
            </td>

            <td style={{ color: "red" }} className="text-center">
              {getFeeSum(res)}
            </td>
          </tr>
        </>
      );
    } else if (feeMonthsLength == 3) {
      return (
        <>
          <tr id="tbl">
            <td style={{ textAlign: "start" }}>
              <input type="checkbox" style={{ display: "none" }} />
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  key={student.id}
                  onClick={(e) => {
                    handleChallansCheckBoxClick(e, student.id);
                  }}
                  checked={student.checked}
                  value={allcheckboxes[index]}
                />
                <span />
              </label>
            </td>
            <td className="text_align_start" style={{ color: "#fd12b3" }}>
              {student.admission_id}
            </td>
            <td className="text_align_start" style={{ color: "#fd12b3" }}>
              {student.name}
            </td>
            <td className="text_align_start" style={{ color: "#fd12b3" }}>
              {student.father_name}
            </td>
            <td className="text-center" style={{ color: "#fd12b3" }}>
              {student.mobile_no}
            </td>

            <td className="text-center" style={{ color: "#fd12b3" }}>
              {student?.student_class?.name}
            </td>
            <td className="text-center" style={{ color: "#fd12b3" }}>
              {student?.global_section?.name}
            </td>

            <td>
              <span className="text-center" style={{ color: "#fd12b3" }}>
                {feeMonths.join(", ")}
              </span>
            </td>

            <td style={{ color: "#fd12b3" }} className="text-center">
              {feeMonthsLength}
            </td>

            <td style={{ color: "#fd12b3" }} className="text-center">
              {getFeeSum(res)}
            </td>
          </tr>
        </>
      );
    } else if (feeMonthsLength == 2) {
      return (
        <>
          <tr id="tbl">
            <td style={{ textAlign: "start" }}>
              <input type="checkbox" style={{ display: "none" }} />
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  key={student.id}
                  onClick={(e) => {
                    handleChallansCheckBoxClick(e, student.id);
                  }}
                  checked={student.checked}
                  value={allcheckboxes[index]}
                />
                <span />
              </label>
            </td>
            <td className="text_align_start" style={{ color: "green" }}>
              {student.admission_id}
            </td>
            <td className="text_align_start" style={{ color: "green" }}>
              {student.name}
            </td>
            <td className="text_align_start" style={{ color: "green" }}>
              {student.father_name}
            </td>
            <td className="text-center" style={{ color: "green" }}>
              {student.mobile_no}
            </td>

            <td className="text-center" style={{ color: "green" }}>
              {student?.student_class?.name}
            </td>
            <td className="text-center" style={{ color: "green" }}>
              {student?.global_section?.name}
            </td>

            <td>
              <span className="text-center" style={{ color: "green" }}>
                {feeMonths.join(", ")}
              </span>
            </td>

            <td style={{ color: "green" }} className="text-center">
              {feeMonthsLength}
            </td>

            <td style={{ color: "green" }} className="text-center">
              {getFeeSum(res)}
            </td>
          </tr>
        </>
      );
    } else {
      return (
        <>
          <tr id="tbl">
            <td style={{ textAlign: "start" }}>
              <input type="checkbox" style={{ display: "none" }} />
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  key={student.id}
                  onClick={(e) => {
                    handleChallansCheckBoxClick(e, student.id);
                  }}
                  checked={student.checked}
                  value={allcheckboxes[index]}
                />
                <span />
              </label>
            </td>
            <td className="text_align_start" style={{ color: "black" }}>
              {student.admission_id}
            </td>
            <td className="text_align_start" style={{ color: "black" }}>
              {student.name}
            </td>
            <td className="text_align_start" style={{ color: "black" }}>
              {student.father_name}
            </td>
            <td className="text-center" style={{ color: "black" }}>
              {student.mobile_no}
            </td>

            <td className="text-center" style={{ color: "black" }}>
              {student?.student_class?.name}
            </td>
            <td className="text-center" style={{ color: "black" }}>
              {student?.global_section?.name}
            </td>

            <td>
              <span className="text-center" style={{ color: "black" }}>
                {feeMonths.join(", ")}
              </span>
            </td>

            <td style={{ color: "black" }} className="text-center">
              {feeMonthsLength}
            </td>

            <td style={{ color: "black" }} className="text-center">
              {getFeeSum(res)}
            </td>
          </tr>
        </>
      );
    }
  };

  return (
    <>
      {contextHolder}
      <div>
        <Toaster />
        <Paper
          style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
        >
          <div>
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-sm-3">
                  <input
                    disabled={
                      !PremissionChecker(
                        user,
                        "system_reports.session_wise_due_fee"
                      )
                    }
                    checked={selected == "session"}
                    onChange={(e) => onRadioButtonClick(e)}
                    type="radio"
                    id="Session"
                    name="contact"
                    value="session"
                  />
                  <label htmlFor="Session">Session Wise Due Fee</label>
                </div>

                <div className="col-sm-3">
                  <input
                    checked={selected == "campus"}
                    onChange={(e) => onRadioButtonClick(e)}
                    type="radio"
                    id="Campus"
                    name="contact"
                    value="campus"
                  />
                  <label htmlFor="Campus">Campus Wise Due Fee</label>
                </div>

                <div className="col-sm-3">
                  <input
                    checked={selected == "course"}
                    onChange={(e) => onRadioButtonClick(e)}
                    type="radio"
                    id="Course"
                    name="contact"
                    value="course"
                  />
                  <label htmlFor="Course">Course Wise Due Fee</label>
                </div>

                <div className="col-sm-3">
                  <input
                    checked={selected == "class"}
                    onChange={(e) => onRadioButtonClick(e)}
                    type="radio"
                    id="Class"
                    name="contact"
                    value="class"
                  />
                  <label htmlFor="Class">Class Wise Due Fee</label>
                </div>
                <div className="col-sm-3">
                  <input
                    checked={selected == "section"}
                    onChange={(e) => onRadioButtonClick(e)}
                    type="radio"
                    id="Section"
                    name="contact"
                    value="section"
                  />
                  <label htmlFor="Section">Section Wise Due Fee</label>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3">
                  <input
                    checked={gender == "male"}
                    onChange={(e) => ongenderButtonClick(e)}
                    type="radio"
                    id="Male"
                    name="gender"
                    value="male"
                  />
                  <label htmlFor="Male">Male</label>
                </div>

                <div className="col-sm-3">
                  <input
                    type="radio"
                    checked={gender == "female"}
                    onChange={(e) => ongenderButtonClick(e)}
                    id="Female"
                    name="gender"
                    value="female"
                  />
                  <label htmlFor="Female">Female</label>
                </div>

                <div className="col-sm-3">
                  <input
                    checked={gender == "both"}
                    onChange={(e) => ongenderButtonClick(e)}
                    type="radio"
                    id="Both"
                    name="gender"
                    value="both"
                  />
                  <label htmlFor="Both">Both</label>
                </div>
              </div>
              <br />
              <div className="d-flex" style={{ flexWrap: "wrap" }}>
                <div className="col-sm-3">
                  <label>
                    <b>Select Session</b>
                  </label>
                  <div className="d-flex flex-column ">
                    <select
                      style={{ height: 40 }}
                      className="form-select"
                      name="year_id"
                      value={yearId}
                      aria-label="Default select example"
                      onChange={(e) => setYearId(e.target.value)}
                    >
                      <option value="">Select Session</option>
                      {sessionData &&
                        sessionData.map((item, index) => (
                          <option key={index} value={item.id}>
                            {item.year}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                {session ? null : (
                  <div className="col-sm-3">
                    <label>
                      <b>Select Campus</b>
                    </label>
                    <div className="d-flex flex-column">
                      <select
                        onChange={(e) => onCampusChange(e.target.value)}
                        className="form-select"
                        style={{ backgroundColor: "white", height: 40 }}
                        value={campusId}
                        aria-label="Default select example"
                      >
                        <option value="">Select Campus</option>
                        {campuses.map((campus, index) => (
                          <option key={index} value={campus.id}>
                            {campus.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}

                {session || campus ? null : (
                  <>
                    <div className="col-sm-3">
                      <label>
                        <b>Select Course</b>
                      </label>
                      <div className="d-flex flex-column">
                        <select
                          className="form-select form-control"
                          name="course_id"
                          value={courseId}
                          onChange={(e) => onCourseChange(e.target.value)}
                          style={{ backgroundColor: "white", height: 40 }}
                          aria-label="Default select example"
                        >
                          <option value="">Select Course</option>
                          {campusCourseData.map((item, index) => (
                            <option key={index} value={item.course?.id}>
                              {item.course?.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </>
                )}

                {session || campus || courses ? null : (
                  <>
                    <div className="col-sm-3">
                      <label>
                        <b>Select Class</b>
                      </label>
                      <div className="d-flex flex-column">
                        <select
                          className="form-select form-control"
                          name="class_id"
                          value={classId}
                          onChange={(e) => onClassChange(e.target.value)}
                          style={{ backgroundColor: "white", height: 40 }}
                          aria-label="Default select example"
                        >
                          <option value="">Select Class</option>
                          {courseClassData.map((item, index) => (
                            <option key={index} value={item.class?.id}>
                              {item.class?.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </>
                )}

                {session || classes || campus || courses ? null : (
                  <div className="col-sm-3 mt-4">
                    <label>
                      <b>Select Section</b>
                    </label>
                    <div className="d-flex flex-column">
                      <select
                        className="form-select form-control"
                        name="section_id"
                        value={sectionId}
                        onChange={(e) => setSectionId(e.target.value)}
                        style={{ backgroundColor: "white" }}
                        aria-label="Default select example"
                      >
                        <option value="">Select Section</option>
                        {classSectionData.map((item, index) => (
                          <option key={index} value={item.section?.id}>
                            {item.section?.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}
              </div>
              <br />
              <div className="mx-4">
                <div className="d-flex">
                  <div className="w-25">
                    <label>
                      <b>Select Start and End Date</b>
                    </label>
                    <RangePicker
                      style={{ height: "40px" }}
                      picker="month"
                      onChange={datePicker}
                    />
                  </div>
                  <div className="col-md-4 mt-9">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      id="over_due_date"
                      checked={overDueDate ? overDueDate == 1 : false}
                      onChange={(e) => setOverDueDate(e.target.checked ? 1 : 0)}
                    ></input>
                    <label htmlFor="over_due_date" className="form-check-label">
                      Due Date Passed
                    </label>
                  </div>
                </div>
              </div>
              <br />
              <div className="d-flex">
                <div className="d-flex flex-column col-sm-3">
                  <label>
                    <b>Select Fee Type</b>
                  </label>
                  <select
                    style={{ height: 40 }}
                    className="form-select"
                    name="year_id"
                    value={feeType}
                    aria-label="Default select example"
                    onChange={(e) => setFeeType(e.target.value)}
                  >
                    <option value="">All Type Of Fees</option>
                    {fee_types.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="d-flex flex-column col-sm-3">
                  <label>
                    <b>Select Status</b>
                  </label>
                  <select
                    style={{ height: 40 }}
                    className="form-select"
                    name="year_id"
                    value={studentStatus}
                    aria-label="Default select example"
                    onChange={(e) => setStudentStatus(e.target.value)}
                  >
                    <option value="">Select Status</option>
                    {STUD_STATUS.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <br />
              <div className="row">
                <div className="col-md-8">
                  <button className="btn btn-primary" type="submit">
                    Show
                  </button>
                </div>
              </div>
            </form>
            <div className="mt-5">
              {!!selectedChallans && selectedChallans.length > 0 ? (
                <div>
                  <button className="btn btn-primary" onClick={handlePrint}>
                    Preview
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary mx-3"
                    onClick={sendMesagePreview}
                  >
                    Send Message
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary mx-3"
                    onClick={sendNotification}
                  >
                    Send Notification
                  </button>
                </div>
              ) : null}
            </div>
            {studentsData.length > 0 ? (
              <div style={{ display: "flex", justifyContent: "end" }}>
                <h3>Grand Total: {mainTableGrandTotal(studentsData)}</h3>
              </div>
            ) : (
              ""
            )}
            {loading ? (
              <div className="row justify-content-center">
                <Spinner
                  className="text-center"
                  variant="info"
                  animation="border"
                />
              </div>
            ) : (
              <div id="tableboot">
                <Table responsive>
                  <thead>
                    <tr id="tbl">
                      <th>
                        <input type="checkbox" style={{ display: "none" }} />
                        <label className="checkbox checkbox-single">
                          <input
                            onClick={(e) => {
                              handleMainCheckboxClick();
                            }}
                            checked={mainCheckBoxChecked}
                            placeholder="Checkbox"
                            type="checkbox"
                            readOnly
                          />
                          <span />
                        </label>
                      </th>
                      <th>Adm-Id</th>
                      <th>Student Name</th>
                      <th>Father Name</th>
                      <th className="text-center">Mobile No</th>
                      <th className="text-center">Class</th>
                      <th className="text-center">Section</th>
                      <th className="text-center">Months</th>
                      <th className="text-center">Total Month Due</th>
                      <th className="text-center">Total Fee</th>
                    </tr>
                  </thead>

                  <tbody>
                    {!!studentsData &&
                      studentsData.map((student, index) => (
                        <React.Fragment key={index}>
                          {renderTableRow(student, index)}
                        </React.Fragment>
                      ))}
                  </tbody>
                </Table>
              </div>
            )}
          </div>

          {/* <div
            ref={componentRef}
            id="printSection"
            className="customTablePrint"
          >
            <div className="p-3" style={{ display: "flex" }}>
              <img style={{ height: 100, width: 110 }} src={icon} />

              <div className="col-md-8" style={{ paddingTop: "10px" }}>
                <h1>{unitName}</h1>
                <p className="paybodyFont nextmoreFont">
                  <b>
                    Student Due Fee Report As On {todayDate()} {currentTime()}
                  </b>
                </p>
              </div>
            </div>
            <Table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr id="tbl">
                  <th
                    style={{
                      color: "black",
                      textAlign: "center",
                      borderBottom: "1px solid black",
                      fontSize: "16px",
                    }}
                  >
                    Sr.No
                  </th>
                  <th
                    style={{
                      color: "black",
                      textAlign: "center",
                      borderBottom: "1px solid black",
                      fontSize: "16px",
                    }}
                  >
                    Adm. No
                  </th>
                  <th
                    style={{
                      color: "black",
                      textAlign: "center",
                      borderBottom: "1px solid black",
                      fontSize: "16px",
                    }}
                  >
                    Student Name
                  </th>
                  <th
                    style={{
                      color: "black",
                      textAlign: "center",
                      borderBottom: "1px solid black",
                      fontSize: "16px",
                    }}
                  >
                    Father Name
                  </th>
                  <th
                    style={{
                      color: "black",
                      textAlign: "center",
                      borderBottom: "1px solid black",
                      fontSize: "16px",
                    }}
                  >
                    Mobile No
                  </th>
                  <th
                    style={{
                      color: "black",
                      textAlign: "center",
                      borderBottom: "1px solid black",
                      fontSize: "16px",
                    }}
                  >
                    Months
                  </th>
                  <th
                    style={{
                      color: "black",
                      textAlign: "center",
                      borderBottom: "1px solid black",
                      fontSize: "16px",
                    }}
                  >
                    Total Months
                  </th>
                  <th
                    style={{
                      color: "black",
                      textAlign: "center",
                      borderBottom: "1px solid black",
                      fontSize: "16px",
                    }}
                  >
                    Total Fee
                  </th>
                </tr>
              </thead>
              <tbody>
                {printData &&
                  printData.map((item, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td
                          colSpan={8}
                          style={{ textAlign: "left", padding: "10px" }}
                        >
                          <h3 className="text-primary">{item.campus_name}</h3>
                        </td>
                      </tr>
                      {item.classes?.map((subitem) =>
                        subitem.sections.map((miniitems, index) => (
                          <React.Fragment key={index}>
                            <tr>
                              <td></td>
                              <td
                                colSpan={3}
                                style={{
                                  color: "black",
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                  textAlign: "start",
                                  padding: "1px",
                                }}
                              >
                                <b>Class:- {subitem?.class_name}</b>
                              </td>
                              <td
                                colSpan={3}
                                style={{
                                  color: "black",
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                  textAlign: "start",
                                  padding: "1px",
                                }}
                              >
                                <b>Section: {miniitems.section_name}</b>
                              </td>
                            </tr>
                            {miniitems.students.map((student, i) => (
                              <tr
                                key={i}
                                style={{
                                  fontSize: "14px",
                                  color: "black",
                                  textAlign: "center",
                                  padding: "1px",
                                }}
                              >
                                <td>{i + 1}</td>
                                <td>{student.admission_id}</td>
                                <td style={{ textAlign: "start" }}>
                                  {student.student_name}
                                </td>
                                <td style={{ textAlign: "start" }}>
                                  {student.father_name}
                                </td>
                                <td>{student.mobile_no}</td>
                                <td>
                                  {student?.fee_months.map((month, i) => (
                                    <span key={i}>
                                      {i !== 0 && ", "}
                                      {getMonthName(month)}
                                    </span>
                                  ))}
                                </td>
                                <td>{student.total_months}</td>
                                <td>{student.total_fee}</td>
                              </tr>
                            ))}
                            <tr>
                              <td colSpan={5}></td>
                              <td
                                className="text-primary"
                                colSpan={3}
                                style={{
                                  textAlign: "end",
                                  fontSize: "16px",
                                  borderBottom: "2px solid black",
                                }}
                              >
                                <b>Sub Total: </b> {miniitems?.section_amount}
                              </td>
                            </tr>
                          </React.Fragment>
                        ))
                      )}
                      <tr>
                        <td colSpan={5}></td>
                        <td
                          className="text-primary"
                          colSpan={3}
                          style={{
                            textAlign: "end",
                            fontSize: "16px",
                            borderBottom: "2px solid black",
                          }}
                        >
                          <b>{item.campus_name} Total Due Fee: </b>{" "}
                          {item.amount}
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
                <tr>
                  <td colSpan={5}></td>
                  <td
                    className="text-primary"
                    colSpan={3}
                    style={{
                      textAlign: "end",
                      fontSize: "20px",
                      borderBottom: "2px solid black",
                    }}
                  >
                    <b>Grand Total: {grandTotal}</b>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div> */}

          <div
            ref={componentRef}
            id="printSection"
            className="customTablePrint"
          >
            <div className="p-3" style={{ display: "flex" }}>
              <img style={{ height: 100, width: 110 }} src={icon} />

              <div className="col-md-8" style={{ paddingTop: "10px" }}>
                <h1>{unitName}</h1>
                <p className="paybodyFont nextmoreFont">
                  <b>
                    Student Due Fee Report As On {todayDate()} {currentTime()}
                  </b>
                </p>
              </div>
            </div>
            <table style={{ width: "100%" }}>
              <thead style={{ marginTop: "20px" }}>
                <tr id="tbl" className="duefeeetd">
                  <td
                    style={{
                      color: "black",
                      textAlign: "center",
                      borderBottom: "1px solid black",
                    }}
                  >
                    <b>Sr.no</b>
                  </td>
                  <td
                    style={{
                      color: "black",
                      textAlign: "center",
                      borderBottom: "1px solid black",
                    }}
                  >
                    <b>Adm-Id</b>
                  </td>
                  <td
                    style={{
                      color: "black",
                      textAlign: "start",
                      borderBottom: "1px solid black",
                    }}
                  >
                    <b>Student Name</b>
                  </td>
                  <td
                    style={{
                      color: "black",
                      textAlign: "start",
                      borderBottom: "1px solid black",
                    }}
                  >
                    <b>Father Name</b>
                  </td>
                  <td
                    style={{
                      color: "black",
                      textAlign: "center",
                      borderBottom: "1px solid black",
                    }}
                  >
                    <b>Mobile No</b>
                  </td>
                  <td
                    style={{
                      color: "black",
                      textAlign: "center",
                      borderBottom: "1px solid black",
                    }}
                  >
                    <b>Months</b>
                  </td>
                  <td
                    style={{
                      color: "black",
                      textAlign: "center",
                      borderBottom: "1px solid black",
                    }}
                  >
                    <b>Total Months</b>
                  </td>
                  <td
                    style={{
                      color: "black",
                      textAlign: "center",
                      borderBottom: "1px solid black",
                    }}
                  >
                    <b>Total Fee</b>
                  </td>
                </tr>
              </thead>
              {printData &&
                printData.map((item) => (
                  <>
                    <tr>
                      <td colSpan={7}>
                        <div
                          className="d-flex"
                          style={{ marginTop: "5px", marginLeft: "10px" }}
                        >
                          <div className="">
                            <h3 className="text-primary">{item.campus_name}</h3>
                          </div>
                        </div>
                      </td>
                    </tr>
                    {item.classes?.map((subitem) =>
                      subitem.sections.map((miniitems) => (
                        <>
                          <tbody>
                            <div
                              className="hadhybhai"
                              style={{
                                height: "20px",
                                display: "flex",
                                marginTop: "10px",
                                position: "relative",
                              }}
                            >
                              <p
                                style={{
                                  color: "black",
                                  // fontWeight: "bold",
                                  fontSize: "18px",
                                  position: "absolute",
                                  left: "30px",
                                }}
                                className="text_align_start duefeesec"
                              >
                                {" "}
                                <b>Class:- {subitem?.class_name}</b>
                              </p>

                              <p
                                style={{
                                  color: "black",
                                  fontSize: "18px",
                                  position: "absolute",
                                  left: "350px",
                                }}
                                className="text_align_start duefeesec"
                              >
                                <b>Section: {miniitems.section_name}</b>
                              </p>
                            </div>
                            {miniitems.students.map((student, i) => (
                              <tr id="tbl" className="duefeeetd">
                                <td
                                  style={{
                                    color: "black",
                                    textAlign: "center",
                                  }}
                                >
                                  {(num2 += 1)}
                                </td>
                                <td
                                  style={{
                                    color: "black",
                                    textAlign: "center",
                                  }}
                                >
                                  {student.admission_id}
                                </td>
                                <td
                                  style={{
                                    color: "black",
                                    textAlign: "start",
                                  }}
                                >
                                  {student.student_name}
                                </td>
                                <td
                                  style={{
                                    color: "black",
                                    textAlign: "start",
                                  }}
                                >
                                  {student.father_name}
                                </td>
                                <td
                                  style={{
                                    color: "black",
                                    textAlign: "center",
                                  }}
                                >
                                  {student.mobile_no}
                                </td>

                                <td
                                  style={{
                                    color: "black",
                                    textAlign: "center",
                                  }}
                                >
                                  {student?.fee_months.map((item, i) => (
                                    <>
                                      <span
                                        style={{
                                          color: "black",
                                          textAlign: "center",
                                        }}
                                      >
                                        <b>{i == "0" ? "" : ","} </b>
                                        {getMonthName(item)}
                                      </span>
                                    </>
                                  ))}
                                </td>
                                <td
                                  style={{
                                    color: "black",
                                    textAlign: "center",
                                  }}
                                >
                                  {student.total_months}
                                </td>

                                <td
                                  style={{
                                    color: "black",
                                    textAlign: "center",
                                  }}
                                >
                                  {student.total_fee}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                          <tr>
                            <td colSpan={8} style={{ textAlign: "end" }}>
                              <div
                                className=""
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  paddingRight: "35px",
                                  fontSize: "2.5rem",
                                }}
                              >
                                <h5 className="text-primary">Sub Total: </h5>
                                <h5>{miniitems?.section_amount}</h5>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={8}>
                              <div
                                style={{
                                  width: "100%",
                                  height: "2px",
                                  border: "1px solid black",
                                }}
                              ></div>
                            </td>
                          </tr>
                        </>
                      ))
                    )}
                    <tr>
                      <td colSpan={8} style={{ textAlign: "end" }}>
                        <div
                          className="col-md-12 d-flex "
                          style={{
                            justifyContent: "flex-end",
                            paddingRight: "35px",
                            marginTop: "5px",
                            fontSize: "3rem",
                          }}
                        >
                          <h4 className="text-primary">
                            {item.campus_name} Total Due Fee:{" "}
                          </h4>
                          <h4 style={{ borderBottom: "1px solid black" }}>
                            {item.amount}
                          </h4>
                        </div>
                      </td>
                    </tr>
                  </>
                ))}
              <tr>
                <td colSpan={8} style={{ textAlign: "end" }}>
                  <div>
                    <div
                      className="col-md-12"
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        paddingRight: "35px",
                        marginTop: "5px",
                      }}
                    >
                      <h1
                        style={{ paddingTop: "5px" }}
                        className="text-primary"
                      >
                        Grand Total:- {grandTotal}
                      </h1>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </Paper>

        {/* /////Model start */}
        <Modal
          show={show}
          onHide={handleClose}
          animation={false}
          size="lg"
          scrollable={true}
        >
          <Modal.Header closeButton>
            <Modal.Title>Students</Modal.Title>
          </Modal.Header>
          {printLoading ? (
            <LinearProgress
              style={{ width: "100%", backgroundColor: "#121291" }}
            />
          ) : (
            <>
              <Modal.Body>
                {printData &&
                  printData.map((item, index) => (
                    <React.Fragment key={index}>
                      <div className="row">
                        <div className="col-md-6">
                          <h4 className="text-primary">{item.campus_name}</h4>
                        </div>
                        {/* <div className="col-md-6 d-flex">
                          <h4 className="text-primary">Total Amount:-</h4>
                          <h4>{item.amount}</h4>
                        </div> */}
                      </div>
                      {item.classes?.map((subitem, index) => (
                        <React.Fragment key={index}>
                          <div>
                            {subitem.sections.map((miniitems, index) => (
                              <React.Fragment key={index}>
                                <div className="">
                                  <div className="col-md-6 d-flex">
                                    <h4>Class:- </h4>
                                    <h4>{subitem?.class_name}</h4>
                                  </div>
                                  <div
                                    className="d-flex"
                                    style={{
                                      paddingLeft: "30px",
                                      paddingTop: "10px",
                                    }}
                                  >
                                    <h4>Section:- </h4>
                                    <h4>{miniitems.section_name}</h4>
                                  </div>

                                  <Table responsive>
                                    <thead>
                                      <tr id="tbl">
                                        <th className="text-center">SNo.</th>
                                        <th className="text-center">AdmId.</th>
                                        <th>Name</th>
                                        <th>Father Name</th>
                                        <th className="text-center">
                                          Mobile No
                                        </th>
                                        <th className="text-center">Months</th>
                                        <th className="text-center">
                                          Total Months
                                        </th>
                                        <th className="text-center">
                                          Total Fee
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {miniitems.students.map((student, i) => (
                                        <tr key={i} id="tbl">
                                          <td
                                            style={{ color: "black" }}
                                            className="text-center"
                                          >
                                            {i + 1}
                                          </td>
                                          <td
                                            style={{ color: "black" }}
                                            className="text-center"
                                          >
                                            {student.admission_id}
                                          </td>
                                          <td
                                            style={{ color: "black" }}
                                            className="text_align_start"
                                          >
                                            {student.student_name}
                                          </td>
                                          <td
                                            style={{ color: "black" }}
                                            className="text_align_start"
                                          >
                                            {student.father_name}
                                          </td>
                                          <td
                                            style={{ color: "black" }}
                                            className="text-center"
                                          >
                                            {student.mobile_no}
                                          </td>

                                          <td
                                            className="text-center"
                                            style={{ color: "black" }}
                                          >
                                            {student?.fee_months.map(
                                              (item, i) => (
                                                <React.Fragment key={i}>
                                                  <span
                                                    style={{
                                                      color: "black",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    <b>
                                                      {i == "0" ? "" : ","}{" "}
                                                    </b>
                                                    {getMonthName(item)}
                                                  </span>
                                                </React.Fragment>
                                              )
                                            )}
                                          </td>
                                          <td
                                            style={{ color: "black" }}
                                            className="text-center"
                                          >
                                            {student.total_months}
                                          </td>

                                          <td
                                            style={{ color: "black" }}
                                            className="text-center"
                                          >
                                            {student.total_fee}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </Table>
                                  <div
                                    className="col-md-12 d-flex "
                                    style={{
                                      justifyContent: "flex-end",
                                      paddingRight: "19px",
                                    }}
                                  >
                                    <h6 className="text-primary">
                                      Sub Total: {miniitems?.section_amount}
                                    </h6>
                                  </div>
                                </div>
                              </React.Fragment>
                            ))}
                          </div>
                        </React.Fragment>
                      ))}
                      <div
                        className="col-md-12 d-flex "
                        style={{ justifyContent: "flex-end", marginTop: "5px" }}
                      >
                        <h6 className="text-primary">
                          {item.campus_name} Total Due Fee: {item.amount}
                        </h6>
                      </div>
                    </React.Fragment>
                  ))}
                <div>
                  <div
                    className="col-md-12 d-flex mt-4"
                    style={{ justifyContent: "flex-end" }}
                  >
                    <h4 style={{ paddingTop: "5px" }} className="text-primary">
                      Grand Total:- {grandTotal}
                    </h4>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Close
                </Button>

                <DueFeeExport printData={printData} grandTotal={grandTotal} />
                <ReactToPrint
                  pageStyle={pageStyle}
                  documentTitle={`Student Due Fee Report`}
                  onAfterPrint={handleAfterPrint}
                  onBeforeGetContent={handleOnBeforeGetContent}
                  onBeforePrint={handleBeforePrint}
                  removeAfterPrint={true}
                  trigger={() => (
                    <button
                      disabled={printloading ? true : false}
                      className="btn btn-success button_blue button_blue"
                    >
                      {printloading ? <span>Printing..</span> : "Print"}
                    </button>
                  )}
                  content={() => componentRef.current}
                />
              </Modal.Footer>
            </>
          )}
        </Modal>
      </div>
      <AntdModal
        title="Send Message"
        centered
        open={messageModel}
        onOk={sendMessage}
        okText="Send Message"
        okButtonProps={{ disabled: buttonDisabled }}
        onCancel={() => setMessageModel(false)}
      >
        <strong className="text-center">
          Are you sure you want to send the message
        </strong>
      </AntdModal>
      <AntdModal
        title="Send Notification"
        centered
        open={notificationConfirmModal}
        onOk={sendMessageToStudents}
        okText="Send Notification"
        onCancel={() => setNotificationConfirmModal(false)}
      >
        <strong className="text-center">
          Are you sure you want to send the notification
        </strong>
      </AntdModal>
    </>
  );
};

export default StudentDueFee;
